import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { SuiviPrestation } from 'src/app/shared/models/suiviPrestation';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ModaliteReunion } from 'src/app/shared/models/modaliteReunion';
import { TypeEntretien } from 'src/app/shared/models/typeEntretien';
import { Prestation } from 'src/app/shared/models/prestation';

@Component({
	selector: 'app-suiviPrestation-form',
	templateUrl: './suiviPrestation-form.component.html',
	styleUrls: ['./suiviPrestation-form.component.scss']
})
export class SuiviPrestationFormComponent implements OnInit {
	@Input() suiviPrestation: SuiviPrestation;
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() isAddressStructureSelected: { value: boolean };
	@Input() isAddressStructureDefault: { value: boolean };
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();


	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	suiviPrestations: SuiviPrestation[] = null;

	labelIntervenantCapitalized: string;

	selectedaddress?: Address;
	selectedaddressStructure?: Address;
	typeaheadLoading?: boolean;
	addressList: Observable<NominatimResponse[]>;
	addressStructureList: Observable<NominatimResponse[]>;
	searchResults: NominatimResponse[];

	listModaliteReunion: ModaliteReunion[];
	listTypeEntretien: TypeEntretien[];

	isPreferencesActive = false;

	user: User;

	constructor(private logger: LogService, private facade: FacadeService) {
		this.addressList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.address);
		}).pipe(
			mergeMap((token: string) =>
				this.getNominatimDisplaynameAsObservable(token)
			)
		);

		this.addressStructureList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.addressStructure);
		}).pipe(
			mergeMap((token: string) =>
				this.getAddressStructureNominatimDisplaynameAsObservable(token)
			)
		);
	}

	ngOnInit(): void {
		if (this.suiviPrestation) {

			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);
			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			this.facade.typeEntretienService.getAllTypeEntretien().subscribe({
				next: (val) => {
					this.listTypeEntretien = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.modaliteReunionService.getAllModaliteReunion().subscribe({
				next: (val) => {
					this.listModaliteReunion = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			// Deep copy
			//this.listSelectedIntervenant = [...this.suiviPrestation.intervenants];

			if (!this.isAddForm) {
				this.form.patchValue({
					description: this.suiviPrestation.description,
					dateEntretien:
						this.suiviPrestation.dateEntretien !== null && this.suiviPrestation.dateEntretien !== ''
							? new Date(this.suiviPrestation.dateEntretien)
							: null,
					dateProchainEntretien:
						this.suiviPrestation.dateProchainEntretien !== null && this.suiviPrestation.dateProchainEntretien !== ''
							? new Date(this.suiviPrestation.dateProchainEntretien)
							: null,
					typeEntretien: this.suiviPrestation.typeEntretien?.id,
					modaliteReunion: this.suiviPrestation.modaliteReunion?.id,
				});
			} 

		}
	}

	// ngOnChanges(): void {
	// 	// this.mapUnavailabilities();
	// }

	onAddressSelect(event: TypeaheadMatch) {
		this.isAddressDefault.value = false;
		this.isAddressSelected.value = true;
		this.selectedaddress = new Address();
		this.selectedaddress.label = event.item.displayName;
		this.selectedaddress.latitude = event.item.latitude;
		this.selectedaddress.longitude = event.item.longitude;
		this.form.controls['address'].updateValueAndValidity();
	}

	onAddressStructureSelect(event: TypeaheadMatch) {
		this.isAddressStructureDefault.value = false;
		this.isAddressStructureSelected.value = true;
		this.selectedaddressStructure = new Address();
		this.selectedaddressStructure.label = event.item.displayName;
		this.selectedaddressStructure.latitude = event.item.latitude;
		this.selectedaddressStructure.longitude = event.item.longitude;
		this.form.controls['addressStructure'].updateValueAndValidity();
	}

	getAddressStructureNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressStructureSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
		return of(this.searchResults);
	}

	getNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
		return of(this.searchResults);
	}

	selectedAddressKeyUp(e: any) {
		this.isAddressDefault.value = false;
		if (this.selectedaddress && this.selectedaddress.latitude != 0) {
			if (this.selectedaddress?.label === e.value) {
				this.isAddressSelected.value = true;
			}
		}else{
			this.selectedaddress = new Address();
			this.selectedaddress.label = e.value
			this.isAddressSelected.value = true;
		}
		this.form.controls['address'].updateValueAndValidity();
	}

	selectedAddressStructureKeyUp(e: any) {
		this.isAddressStructureDefault.value = false;
		if (this.selectedaddressStructure) {
			if (this.selectedaddressStructure?.label === e.value) {
				this.isAddressStructureSelected.value = true;
			}
		}
		this.form.controls['addressStrcture'].updateValueAndValidity();
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	submitForm() {
		if (
			this.form.valid &&
			(this.isAddressSelected.value || this.isAddressDefault.value)
		) {
			this.isValidateButtonClicked.value = true;
			this.suiviPrestation.typeEntretien = this.listTypeEntretien.find(x => x.id == this.form.get('typeEntretien').value);
			this.suiviPrestation.dateEntretien = this.form.get('dateEntretien').value;
			this.suiviPrestation.dateProchainEntretien = this.form.get('dateProchainEntretien').value;
			this.suiviPrestation.modaliteReunion = this.listModaliteReunion.find(x => x.id == this.form.get('modaliteReunion').value);
			this.suiviPrestation.description = this.form.get('description').value;

			this.sendForm.emit();
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	get typeEntretien() {
		return this.form.get('typeEntretien');
	}
	get dateEntretien() {
		return this.form.get('dateEntretien');
	}
	get dateProchainEntretien() {
		return this.form.get('dateProchainEntretien');
	}
	get modaliteReunion() {
		return this.form.get('modaliteReunion');
	}
	get description() {
		return this.form.get('description');
	}

	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

	
}
